import { getRequest } from "../../services/Requests";
import { mapService } from "../../services/mapService/googleMapService";

export enum STORES_ACTIONS {
  FETCH_STORES_FAILED = "FETCH_STORES_FAILED",
  FETCH_STORES_PENDING = "FETCH_STORES_PENDING",
  FETCH_STORES_SUCCESS = "FETCH_STORES_SUCCESS",
}

export const fetchStoresFailed = (payload) => ({
  type: STORES_ACTIONS.FETCH_STORES_FAILED,
  payload,
});

export const fetchStoresPending = () => ({
  type: STORES_ACTIONS.FETCH_STORES_PENDING,
});

export const fetchStoresSuccess = (payload) => ({
  type: STORES_ACTIONS.FETCH_STORES_SUCCESS,
  payload,
});

export const fetchStores = () => async (dispatch) => {
  dispatch(fetchStoresPending());
  try {
    const response = await getRequest({ url: "public/stores" });
    dispatch(fetchStoresSuccess(response.data));
  } catch (error) {
    dispatch(fetchStoresFailed("server unavailable"));
  }
};
